import { h, render, Component } from 'preact';
import { classNames } from '../utils/utils';
import { appConfig } from '../app.config';
import axios from 'axios';
import TxrPagination from './txr-pagination';
import TxrSpinner from './txr-spinner';

class TxrNewsOverview extends Component {
    state = {
        page: 0,
        total: 0,
        pageSize: 10,
        items: [],
        refresh: {}
    }

    selectPage = (value) => {
        this.load(value);
    }
    componentDidMount() {
        this.load(0);
    }

    load(page) {
        const queryPar = {
            page: page,
            pageSize: this.state.pageSize
        };
        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
          });

        if(params.preview) {
            queryPar.preview = params.preview;
        }
        this.setState({ isLoading: true, isError: false });
        let url = `/news/pages`; 
        const options = {
            method: 'GET',
            // headers: { 'content-type': 'application/x-www-form-urlencoded' },
            params: queryPar,
            url
        };
        return axios(options)
            .then((response) => {
                this.setState({ isLoading: false, isError: false, total: response.data.totalCount, items: response.data.items, page: page });
                this.state.refresh.refreshState(response.data.totalCount, this.state.pageSize, page);
                this.forceUpdate();
            })
            .catch(() => {
                this.setState({ isLoading: false, isError: true });
                this.forceUpdate();
            });
    }
    render() {
        return (
            <div class="txr-news-overview">
                <TxrSpinner show={this.state.isLoading}></TxrSpinner>
                {
                    this.state.items.map(item =>
                        <a class="news-item" href={'news/' + item.slug}>
                            <div class="news-item__data">{item.formattedDate}</div>
                            <div class="news-item__group">
                                <div class="news-item__source">{item.source}</div>
                                <div class="news-item__title">{item.title}</div>
                            </div>
                            <div class="news-item__arrow">
                                    <div class="txr-arrow">
                                        <span class="txr-arrow__line"></span>
                                        <i class="txr-arrow__angle far fa-angle-right"></i>
                                    </div>
                            </div>
                        </a>
                    )
                }
                <TxrPagination refresh={this.state.refresh} pageSize={this.state.pageSize} total={this.state.total} selectPage={(page) => this.selectPage(page)}></TxrPagination>
            </div>
        )
    }
}
export default TxrNewsOverview;
